import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import PersonalService from "services/PersonalService";

let initialState = { data: {} };

export const addPersonal = createAsyncThunk(
  "personal/addPersonal",
  async (body) => {
    const response = await PersonalService.addPersonal(body);
    return response?.results;
  }
);

export const addPersonalSlice = createSlice({
  name: "addPersonal",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(addPersonal, builder);
  },
});

export const selectAddPersonal = (state) => state.addPersonal;

export default addPersonalSlice.reducer;
